import { render, staticRenderFns } from "./edit-material.vue?vue&type=template&id=4b5999ca&scoped=true&"
import script from "./edit-material.vue?vue&type=script&lang=js&"
export * from "./edit-material.vue?vue&type=script&lang=js&"
import style0 from "./edit-material.vue?vue&type=style&index=0&id=4b5999ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5999ca",
  null
  
)

component.options.__file = "edit-material.vue"
export default component.exports